import { ChangeResult } from '../../change-result';
import { ReportProfileRulesComputedDelegate } from '../../profile/report-profile-rules-computed-delegate';

export class ReportProfileResourceChangesBaseModel<A> {
  rulesComputedDelegates: ChangeResult<A>;
}
